<template lang="html">
  <div class="">
    <si-container back="/assistance">
      <v-layout
        wrap
        ma-0
      >
        <v-flex
          xs12
          md8
        >
          <v-card>
            <v-card-title primary-title>
              {{ clientName }}
              <v-spacer />
              <v-menu offset-x>
                <template #activator="{ on }">
                  <v-btn
                    text
                    v-on="on"
                  >
                    <v-icon
                      left
                      :color="request.status !== 'closed' ? 'success' : 'error'"
                    >
                      fiber_manual_record
                    </v-icon>{{ request.status }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="setStatus('open')">
                    <v-list-item-title>
                      <v-icon
                        left
                        color="success"
                      >
                        fiber_manual_record
                      </v-icon>Open
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="setStatus('closed')">
                    <v-list-item-title>
                      <v-icon
                        left
                        color="error"
                      >
                        fiber_manual_record
                      </v-icon>Closed
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-list
              dense
              class="transparent"
            >
              <v-list-item
                v-if="client.phone"
                :href="`tel:${client.phone}`"
              >
                <v-list-item-action> <v-icon>phone</v-icon> </v-list-item-action>
                <v-list-item-title>{{ client.phone }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="client.email"
                :href="`mailto:${client.email}`"
              >
                <v-list-item-action> <v-icon>email</v-icon> </v-list-item-action>
                <v-list-item-title>{{ client.email }}</v-list-item-title>
              </v-list-item>
            </v-list>

            <v-divider />
        
            <v-container
              fluid
              px-4
              pb-4
            >
              <v-slide-y-transition>
                <v-flex
                  v-if="show"
                  xs12
                  py-0
                >
                  <v-layout
                    class="align-center"
                    wrap
                  >
                    <v-flex
                      mr-4
                      shrink
                    >
                      <div class="caption grey--text">
                        Method
                      </div> {{ payment.method }}
                    </v-flex>
                    <v-flex
                      shrink
                      mr-4
                    >
                      <div class="caption grey--text">
                        Paid
                      </div> {{ _$(payment.paid_amount) }}
                    </v-flex>
                    <v-flex
                      v-if="payment.paid_date"
                      mr-4
                      shrink
                    >
                      <div class="caption grey--text">
                        Date
                      </div> {{ _formatDateShort(payment.paid_date) }}
                    </v-flex>
                    <v-flex>
                      <v-layout class="align-center justify-end">
                        <v-flex
                          class="title"
                          :class="request._paid ? '' : 'warning--text'"
                          shrink
                        >
                          {{ _$(payment.total) }}
                        </v-flex>
                        <!-- <v-flex v-if="!request._paid" shrink ><v-btn color="warning" :loading="invoiceLoading" depressed @click="markAsPaid">Mark as paid</v-btn></v-flex> -->
                        <v-menu
                          v-if="request._paid"
                          offset-y
                        >
                          <template #activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="dialog = true">
                              <v-list-item-title>{{ paymentCancelText.actionName }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-alert
                    v-if="request._refund"
                    type="warning"
                    outlined
                    border="left"
                    dense
                    class="mt-2"
                  >
                    <v-layout class="body-1">
                      <v-flex>{{ paymentCancelText.alertTitle }}</v-flex>
                      <v-flex shrink>
                        {{ _$(request._refund.amount) }}
                      </v-flex>
                    </v-layout>
                    <span class="body-2">REASON: {{ request._refund.reason }}</span>
                  </v-alert>
                </v-flex>
              </v-slide-y-transition>
            </v-container>

            <v-divider />

            <v-container
              fluid
              px-4
              pb-4
            >
              <v-slide-y-transition>
                <div v-if="show">
                  <v-flex
                    xs12
                    pa-0
                  >
                    <v-layout wrap>
                      <v-flex
                        xs12
                        md6
                        py-0
                      >
                        <v-flex>
                          <div class="caption grey--text">
                            Calculation
                          </div> {{ publicData.calculationText }}
                        </v-flex>
                        <v-flex>
                          <div class="caption grey--text">
                            Submitted
                          </div> {{ _formatDateTime(requestData.timestamp) }}
                        </v-flex>
                        <v-flex>
                          <div class="caption grey--text">
                            Client Reference
                          </div> {{ client.reference }}
                        </v-flex>
                      </v-flex>
                      <v-flex
                        xs12
                        md6
                        py-0
                      >
                        <v-flex>
                          <div class="caption grey--text">
                            Assistance Type
                          </div> {{ publicData.assistanceText }}
                        </v-flex>
                        <v-flex>
                          <div class="caption grey--text">
                            Due
                          </div> {{ _formatDateTime(_moment(publicData.timestamp).add(publicData.assistanceDuration, 'hours')) }}
                        </v-flex>
                        <v-flex>
                          <div class="caption grey--text">
                            Client View
                          </div><a
                            :href="publicHref"
                            target="blank"
                          >Client assistance tracker </a> <v-icon
                            small
                            color="primary"
                          >
                            launch
                          </v-icon>
                        </v-flex>
                      </v-flex>
                      <v-flex
                        px-4
                        xs12
                      >
                        <div class="caption grey--text ">
                          Remaining Time
                        </div>
                        <v-tooltip
                          v-if="request.status !== 'closed'"
                          top
                        >
                          <template #activator="{ on }">
                            <v-layout
                              align-center
                              ma-0
                              v-on="on"
                            >
                              <v-flex
                                class="text-no-wrap"
                                mr-2
                                pa-0
                              >
                                {{ _timeLeftText(publicData.timestamp, publicData.assistanceDuration) }}
                              </v-flex>
                              <v-progress-linear
                                :value="request.status === 'closed' ? 100 : _elapsedPercent(publicData.timestamp, publicData.assistanceDuration)"
                                :color="request.status === 'closed' ? 'grey' :_elapsedColor(_elapsedPercent(publicData.timestamp, publicData.assistanceDuration))"
                                class="ma-0"
                              />
                            </v-layout>
                          </template>
                          <span>Due: {{ publicData.assistanceDue }}</span>
                        </v-tooltip>
                        <div v-else>
                          CLOSED
                        </div>
                      </v-flex>
                      <v-flex
                        v-if="Object.keys(requestData.addons || {}).length > 0"
                        xs12
                        py-0
                      >
                        <v-flex>
                          <div class="caption grey--text">
                            Addons
                          </div>
                          <div
                            v-for="addon in requestData.addonsDisplay"
                            :key="addon.id"
                            class="my-2"
                          >
                            <v-icon color="primary">
                              library_add
                            </v-icon> {{ addon.name }}
                          </div>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex
                    xs12
                    pb-0
                  >
                    <v-divider />

                    <template v-if="!request._calculated">
                      <v-btn
                        text
                        color="primary"
                        :href="calculationHref"
                        target="blank"
                        :disabled="request._calculated"
                        class="my-3"
                      >
                        <v-icon left>
                          link
                        </v-icon> Start Calculation
                      </v-btn>
                      <v-divider />
                    </template>

                    <template v-if="request._calculated">
                      <v-btn
                        text
                        color="primary"
                        class="my-3"
                        @click="_viewReportWindow((request.calculation || {}).calculatorId, (request.calculation || {}).calculationId)"
                      >
                        View Report<v-icon right>
                          arrow_forward
                        </v-icon>
                      </v-btn>
                      <v-divider />
                    </template>
                  </v-flex>

                  <v-flex class="body-2 mt-2">
                    Notes
                  </v-flex>
                  <v-flex xs12>
                    <v-layout ma-0>
                      <v-flex
                        shrink
                        pt-1
                        px-0
                        pb-0
                      >
                        <SiUserAvatar
                          :uid="_user.uid"
                          size="36"
                          class="mt-2"
                        />
                      </v-flex>
                      <v-flex>
                        <SiInputTextarea
                          v-model="note"
                          rows="2"
                          auto-grow
                          hide-details
                          flat
                          solo
                          label="new note..."
                          append-icon="send"
                          @keydown.ctrl.enter="postNote"
                          @click:append="postNote"
                        />
                      </v-flex>
                    </v-layout>
                    <v-scale-transition group>
                      <v-layout
                        v-for="note in notes"
                        :key="note.id"
                        ma-0
                        py-1
                      >
                        <SiUserAvatar
                          :uid="note.uid"
                          size="36"
                          class="mt-1"
                        />
                        <v-flex
                          py-0
                          pl-2
                        >
                          <div class="">
                            <span class="font-weight-bold mr-2">{{ _userName(note.uid) }}</span>
                            <span class="caption grey--text">{{ _formatDateTime(note.timestamp) }}</span>
                          </div>
                          <span v-html="_formatLineBreaks(note.note)" />
                        </v-flex>
                        <v-flex text-right>
                          <v-btn
                            text
                            icon
                            color="grey"
                            small
                            @click="deleteNote(note.id)"
                          >
                            <v-icon small>
                              close
                            </v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-scale-transition>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider />
                  </v-flex>

                  <v-flex
                    v-if="dataFiles.length > 0"
                    class="body-2 mt-2"
                  >
                    Files
                  </v-flex>
                  <v-list class="transparent">
                    <template v-for="input in dataFiles">
                      <v-list-item
                        v-for="file in input.value"
                        :key="file.id"
                        :href="file.downloadURL"
                        target="blank"
                      >
                        <v-list-item-action> <v-icon>description</v-icon> </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title class="grey--text body-1">
                            {{ input.label }}
                          </v-list-item-title>
                          <v-list-item-title class="caption">
                            {{ file.title }}.{{ file.extension }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                  <v-flex
                    v-if="dataInputs.length > 0"
                    class="body-2 mt-2"
                  >
                    Passed in information
                  </v-flex>
                  <v-card
                    v-for="(input, id) in dataInputs"
                    :key="id"
                    flat
                    class="py-2 px-4"
                    @click="copyValue(input.id)"
                  >
                    <div class="caption grey--text">
                      {{ input.label }}
                    </div>
                    <div
                      class="pt-2"
                      style="white-space: pre-line;"
                    >
                      {{ _formatValue(input.value, input.format) }}
                    </div>
                    <input
                      :ref="input.id"
                      :key="'input' + id"
                      type="hidden"
                      :value="input.value"
                    >
                  </v-card>
                </div>
              </v-slide-y-transition>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <v-flex
            xs12
            class="headline"
          >
            Client progress tracker
            <v-divider />
          </v-flex>
          <v-timeline dense>
            <v-timeline-item
              fill-dot
              class="white--text mb-4 "
              color="white"
              large
            >
              <template #icon>
                <v-menu offset-x>
                  <template #activator="{ on }">
                    <v-btn
                      fab
                      depressed
                      :disabled="request.status === 'closed'"
                      color="secondary"
                      style="min-width: 56px;"
                      v-on="on"
                    >
                      <v-icon color="white">
                        {{ (interactionTypes[interactionType] || {}).icon }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="type in interactionTypesItems"
                      :key="type.value"
                      @click="interactionType = type.value"
                    >
                      <v-list-item-action><v-icon>{{ type.icon }}</v-icon></v-list-item-action>
                      <v-list-item-title>{{ type.text }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <v-textarea
                v-model="interactionComment"
                rows="2"
                auto-grow
                hide-details
                solo
                flat
                label="Interaction description..."
                :disabled="request.status === 'closed'"
                append-icon="send"
                @keydown.enter="() => postInteraction()"
                @click:append="() => postInteraction()"
              />
            </v-timeline-item>
            <v-slide-x-reverse-transition
              group
              hide-on-leave
            >
              <v-timeline-item
                v-for="item in interactions"
                :key="item.id"
                small
                fill-dot
                :icon="item.icon"
              >
                <v-layout align-center>
                  <v-flex xs12>
                    <div class="font-weight-bold">
                      {{ item.title }} <span class="caption grey--text">{{ _formatDateTime(item.timestamp) }}</span>
                    </div>
                    <!-- <div class="caption">{{_formatDate(item.timestamp)}}</div> -->
                    <div class="caption">
                      {{ item.description }}
                    </div>
                  </v-flex>
                  <v-flex
                    shrink
                    class="text-no-wrap caption"
                  >
                    <v-btn
                      v-if="item.id !== '0' && request.status !== 'closed'"
                      text
                      icon
                      small
                      color="grey"
                      class="ma-0"
                      @click="deleteInteraction(item.id)"
                    >
                      <v-icon small>
                        close
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-timeline-item>
            </v-slide-x-reverse-transition>
          </v-timeline>
        </v-flex>
      </v-layout>
    </si-container>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
    >
      Value copied
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="500"
      style="width: 100%;"
      scrollable
    >
      <v-card class="grey lighten-4">
        <v-card-title class="headline warning white--text">
          <v-icon class="white--text mr-2">
            warning
          </v-icon>
          {{ paymentCancelText.dialogTitle }}
        </v-card-title>
        <v-card-text class="pa-6">
          <v-layout wrap>
            <v-flex xs12>
              <SiInputCurrency
                v-model="refund.amount"
                label="Refund amount"
                cents
                outlined
                :error-messages="refundValidation"
                :disabled="paymentCancelText.dialogRefundAmountDisabled"
                required
              />
            </v-flex>
            <v-flex xs12>
              <SiInputTextarea
                v-model="refund.reason"
                label="Refund reason"
                outlined
                required
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click.native="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="warning"
            text
            :disabled=" refund.amount === 0 || !refund.reason || refund.amount > payment.total"
            @click.native="processPaymentCancellation"
          >
            {{ paymentCancelText.dialogButton }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SiLoaderPopup
      :value="refundProcessing"
      color="warning"
      label="Processing Refund"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isEmpty, forEach } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import durations from '@/mixins/durations'
import links from '@/mixins/links'
import users from '@/mixins/users'
import binder from '@/mixins/binder'

export default {
  mixins: [ helpers, durations, links, users, binder ],
  props: {
    requestsIndex: Object
  },
  data () {
    return {
      dialog: false,
      snackbar: false,
      invoiceLoading: false,
      show: false,
      request: {
        clientName: ''
      },
      refundProcessing: false,
      refund: {
        amount: 0,
        reason: ''
      },
      note: '',
      interactionComment: '',
      interactionType: 'comment',
      interactionTypes: {
        comment: { text: 'Comment', value: 'comment', icon: 'comment' },
        phone: { text: 'Phone', value: 'phone', icon: 'phone' },
        email: { text: 'Email', value: 'email', icon: 'email' },
        meeting: { text: 'Meeting', value: 'meeting', icon: 'group' }
      }
    }
  },
  computed: {
    ...mapGetters(['_loader', '_user', '_badgeTotals']),
    assistanceId () {
      return this.$route.params.sub || ''
    },
    clientName () {
      return this.request.clientName || `${this.client.firstName || ''} ${this.client.lastName || ''}`
    },
    client () {
      return ((this.request || {}).request || {}).client || {}
    },
    publicData () {
      return (this.request || {}).public || {}
    },
    requestData () {
      return (this.request || {}).request || {}
    },
    interactions () {
      return this._sortObject(this.publicData.interactions, (o) => Number(new Date(o.timestamp))).reverse()
    },
    interactionTypesItems () {
      return this._sortObject(this.interactionTypes)
    },
    calculationHref () {
      let calculation = this.requestData.calculation || {}
      return `${process.env.VUE_APP_BASE_URL}/calculator/${calculation.calculator}/${calculation.variant}?assistanceId=${this.assistanceId}&calculationId=${this.requestData.id}&name=${this.clientName}`
    },
    requestPath () {
      // return `assistance/requests/${this.uid}/${this.reqId}`
      return `assistance/requests/${this.assistanceId}`
    },
    publicHref () {
      // return `${process.env.VUE_APP_BASE_URL}/assistance/view/${this.uid}/${this.reqId}`
      return `${process.env.VUE_APP_BASE_URL}/assistance/view/${this.assistanceId}`
    },
    notes () {
      return this._sortObject(this.request.notes || {}).reverse()
    },
    payment () {
      return this.request._payment || {}
    },
    dataInputs () {
      let data = []
      forEach(this.requestData.data, (d) => {
        if (d.format !== 'file') data.push(d)
      })
      return data
    },
    dataFiles () {
      let data = []
      forEach(this.requestData.data, (d) => {
        if (d.format === 'file') data.push(d)
      })
      return data
    },
    refundValidation () {
      if (this.refund.amount > this.payment.total) return ['Refund amount cannot be greater than total payment']
      return []
    },
    paymentCancelText () {
      let text = {}
      switch (this.payment.source) {
        case 'stripe': text = {
          actionName: 'Create refund',
          dialogTitle: 'Refund',
          dialogButton: 'Raise refund',
          dialogRefundAmountDisabled: false,
          alertTitle: 'Refund'
        }
        break;
        case 'invoice': text = {
          actionName: 'Cancel invoice',
          dialogTitle: 'Cancel invoice',
          dialogButton: 'Cancel invoice',
          dialogRefundAmountDisabled: true,
          alertTitle: 'Cancelled'
        }
        break;
      }
      return text
    }
  },
  watch: {
    '$route.params.sub' (v) {
      this.invoiceLoading = false
      this.interactionComment = ''
      if (v) {
        this.request.clientName = (this.requestsIndex[v] || {}).client
        this.show = true
        this.bindRequest()
      } else {
        if (this.dbRef) this.dbRef.off()
        this.show = false
        this.request = { clientName: '' }
      }
    }
  },
  beforeMount () {
    this.bindRequest()
  },
  methods: {
    postInteraction (i = {}) {
      let type = i.type || this.interactionType
      let comment = i.comment || this.interactionComment
      let interaction = {
        timestamp: new Date().toISOString(),
        type: type,
        icon: this.interactionTypes[type].icon,
        title: this.interactionTypes[type].text,
        description: comment
      }
      rtdb.ref(`${this.requestPath}/public/interactions`).push(interaction)
      this.interactionComment = ''
    },
    deleteInteraction (id) {
      rtdb.ref(`${this.requestPath}/public/interactions/${id}`).set(null)
    },
    setStatus (status) {
      rtdb.ref(`${this.requestPath}/status`).set(status)
    },
    goback () {
      this.$router.replace('/assistance')
    },
    bindRequest () {
      this.show = false

      const callback = (v) => {
        this.request = !isEmpty(v) ? v : { request: {} }
        this.refund.amount = (v._payment || {}).total
        this.show = true
      }
      
      this.$bindRtdb("request", this.requestPath, { callback })
      // this.unbindAll()
      // this.$bindxxx(rtdb.ref(this.requestPath), v => {
      //   this.request = !isEmpty(v) ? v : { request: {} }
      //   this.refund.amount = (v._payment || {}).total
      //   this.show = true
      // })
    },
    copyValue (id) {
      let input = this.$refs[id][0]
      input.setAttribute('type', 'text')
      input.select()
            
      try {
        var success = document.execCommand('copy')        
        if (this.snackbar) {
          this.snackbar = false
          setTimeout(() => { this.snackbar = success }, 300)
        } else {
          this.snackbar = success
        }
      } catch (err) {
        console.error(err);
      }
      input.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    postNote () {
      let note = {
        timestamp: new Date().toISOString(),
        note: this.note,
        uid: this._user.uid
      }
      rtdb.ref(`${this.requestPath}/notes`).push(note)
      this.note = ''
    },
    deleteNote (id) {
      rtdb.ref(`${this.requestPath}/notes/${id}`).set(null)
    },
    // async markAsPaid () {
    //   this.invoiceLoading = true
    //   const token = await auth.currentUser.getIdToken()

    //   await axios({
    //     url: `${process.env.VUE_APP_API_URL}/invoices/${this.payment.id}/payment`,
    //     method: 'POST',
    //     headers: { Authorization: 'Bearer ' + token },
    //     data: {
    //       amount: this.payment.total,
    //       source: 'console'
    //     }
    //   })
    //   this.invoiceLoading = false
    // },
    processPaymentCancellation () {
      if (this.payment.source === 'stripe'){
        rtdb.ref(`stripe/refunds/${this.assistanceId}/request`).set({
          ...this.refund,
          timestamp: new Date().toISOString()
        })
        this.refundProcessing = true
        this.dialog = false
        let listener = rtdb.ref(`stripe/refunds/${this.assistanceId}/outcome`).on('value', s => {
          if (s) {
            let outcome = s.val()
            if (outcome && outcome.status === 'succeeded' && this.refundProcessing) {
              listener()
              this.postInteraction({ type: 'comment', comment: `You have been refunded ${this._$(this.refund.amount)}. Reason: ${this.refund.reason}`})
              this.refundProcessing = false
            }
          }
        })
      } else if (this.payment.source === 'invoice') {
        rtdb.ref(`invoicing/invoices/${this.assistanceId}/cancel`).set({
          ...this.refund,
          timestamp: new Date().toISOString()
          })
        this.dialog = false
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>
